import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { MultiSelectFilterOption } from '../../../generic/Filter/MultiSelectFilter';

/**
 * Fetches the list of relevant CWEs whenever the current category, status, or scope changes.
 */
const useCwes = (): { isLoading: boolean; cwes: MultiSelectFilterOption[]; } => {
  const dispatch = useDispatch();

  const { isLoading, value: cwes } = useSelector(IssuesV2Store.selectors.getCwes);
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const status = useSelector(IssuesV2Store.selectors.getStatus);
  const scope = useSelector(IssuesV2Store.selectors.getScope);

  // reset the current selection and fetch updated CWEs whenever
  // the current category, status, or scope changes
  useEffect(() => {
    dispatch(IssuesV2Store.actions.setCwesFilter([]));
    dispatch(IssuesV2Store.actions.fetchCwes(category, status, scope));
  }, [dispatch, category, status, scope]);

  const options = cwes?.map((option) => ({ label: option, value: option }));

  return {
    isLoading,
    cwes: options || [],
  };
};

export default useCwes;
